import '@popperjs/core';
import 'bootstrap';

import '@/front/patch/urlAdaptor';

import '@/front/cldr';

import '@/front/accountPicker';
import '@/front/action';
import '@/front/bookkeepingFrequencyPicker';
import '@/front/companyTypePicker';
import '@/front/dashboard';
import { setDeviceId } from '@/front/device';
import '@/front/editable';
import '@/front/formatters';
import '@/front/grid';
import '@/front/lookupPicker';
import '@/front/modal';
import '@/front/offcanvas';
import '@/front/payrollFrequencyPicker';
import '@/front/placeholderPopup';
import '@/front/resize';
import '@/front/scheduleFrequencyPicker';
import '@/front/schedulePreview';
import '@/front/search';
import '@/front/smartTaskTypePicker';
import '@/front/subTask';
import '@/front/taskClientTypePicker';
import '@/front/templatePicker';
import '@/front/tooltip';
import '@/front/widthToggle';

document.addEventListener('DOMContentLoaded', () => {
  setDeviceId();

  const { hash } = window.location;

  if (hash) {
    const link = document.getElementById(hash.substring(1)) as HTMLAnchorElement | null;

    if (link?.href) {
      link.click();
    }
  }
});

const w = window as any;

w.prefillBeacon = (data: { subject: string; text: string }) => {
  w.Beacon('prefill', data);
  w.Beacon('open');
  w.Beacon('navigate', '/ask/message/');
};
